import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Table, Button, Modal, Form, Badge, InputGroup, FormControl, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";
import { gastosService, empleadosService, tiposService } from "../services/api";
import { FaPlus, FaEdit, FaSearch } from "react-icons/fa";
import "./TiposList.css";

const TiposList = () => {
  const [tipos, setTipos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingTipo, setEditingTipo] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTipos, setFilteredTipos] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("funciones-departamento");

  const [formData, setFormData] = useState({
    nombre: "",
    activo: true,
    // Hora opcional para envío de notificación al fichar entrada (solo departamentos)
    envioNotificacionFicharEntrada: "",
    mesesHastaProxRenovacion: "",
    diasAvisoCaducaPronto: "",
    documentoSinRenovacion: false,
    plantillaVisualmax: "",
    plantillaAutonomo: "",
    envioPlantilla: false,
  });

  // Estados para documentos obligatorios por departamento
  const [documentosObligatorios, setDocumentosObligatorios] = useState([]);
  const [loadingDocumentos, setLoadingDocumentos] = useState(false);

  // Definir las categorías disponibles
  const categorias = [
    {
      id: "funciones-departamento",
      nombre: "Funciones Departamento",
      descripcion: "Tipos de funciones por departamento",
      icon: "🏢",
    },
    {
      id: "contrato-horas",
      nombre: "Contrato Horas",
      descripcion: "Tipos de contratos por horas",
      icon: "📅",
    },
    {
      id: "relacion-laboral",
      nombre: "Relación Laboral",
      descripcion: "Tipos de relaciones laborales",
      icon: "👥",
    },

    {
      id: "factores-seguimiento",
      nombre: "Factores de Seguimiento",
      descripcion: "Factores para seguimiento factorial",
      icon: "📊",
    },
    {
      id: "documentos",
      nombre: "Documentos",
      descripcion: "Tipos de documentos PRL",
      icon: "📄",
    },
  ];

  useEffect(() => {
    loadTipos();
  }, [selectedCategory]);

  useEffect(() => {
    filterTipos();
  }, [searchTerm, tipos]);

  // Inicializar filteredTipos cuando se cargan los tipos
  useEffect(() => {
    if (Array.isArray(tipos)) {
      setFilteredTipos(tipos);
    }
  }, [tipos]);

  // Función auxiliar para mapear datos de tipos
  const mapearDatosTipos = (datos, campoTexto = "TEXTO") => {
    if (!Array.isArray(datos)) return [];

    return datos.map((item) => {
      console.log("Item original:", item);
      const itemMapeado = {
        ...item,
        // Asegurar que siempre tengamos un campo 'id' válido
        id: item.id || item.ID || item.DEPARTAMENTO_ID || item.CONTRATO_ID || item.RELACION_ID || item.FACTOR_ID || "sin-id",
        nombre: item[campoTexto] || item.nombre || item.NOMBRE || "Sin nombre",
      };
      console.log("Item mapeado:", itemMapeado);
      return itemMapeado;
    });
  };

  const loadTipos = async () => {
    try {
      setLoading(true);
      let response;

      switch (selectedCategory) {
        case "funciones-departamento":
          response = await tiposService.getDepartamentos();
          console.log("Respuesta de departamentos:", response);
          const departamentosData = response.data?.departamentos || [];
          console.log("Datos de departamentos:", departamentosData);

          const departamentosMapeados = mapearDatosTipos(departamentosData);
          console.log("Departamentos mapeados:", departamentosMapeados);
          setTipos(departamentosMapeados);
          return;
        case "contrato-horas":
          response = await tiposService.getContratoHoras();
          console.log("Respuesta de contratos:", response);
          const contratosData = response.data?.contratosHoras || [];
          console.log("Datos de contratos:", contratosData);

          const contratosMapeados = mapearDatosTipos(contratosData);
          console.log("Contratos mapeados:", contratosMapeados);
          setTipos(contratosMapeados);
          return;
        case "relacion-laboral":
          response = await tiposService.getRelacionLaboral();
          console.log("Respuesta de relaciones laborales:", response);
          const relacionesData = response.data?.relacionesLaborales || [];
          console.log("Datos de relaciones laborales:", relacionesData);

          const relacionesMapeadas = mapearDatosTipos(relacionesData);
          console.log("Relaciones mapeadas:", relacionesMapeadas);
          setTipos(relacionesMapeadas);
          return;

        case "factores-seguimiento":
          response = await tiposService.getSeguimientoFactorialTipos(null);
          console.log("Respuesta de factores de seguimiento:", response);
          const factoresData = response.data?.tipos || [];
          console.log("Datos de factores de seguimiento:", factoresData);

          const factoresMapeados = mapearDatosTipos(factoresData);
          console.log("Factores mapeados:", factoresMapeados);
          setTipos(factoresMapeados);
          return;
        case "documentos":
          response = await tiposService.getDocumentosTipos();
          console.log("Respuesta de tipos de documentos:", response);
          const documentosData = response.data?.documentTypes || response.data?.documentosTipos || [];
          console.log("Datos de tipos de documentos:", documentosData);

          const documentosMapeados = mapearDatosTipos(documentosData, "NOMBRE");
          console.log("Tipos de documentos mapeados:", documentosMapeados);
          setTipos(documentosMapeados);
          return;
        default:
          response = await tiposService.getTipos();
      }

      console.log("Respuesta general:", response);
      const tiposData = Array.isArray(response.data) ? response.data : [];
      console.log("Datos generales:", tiposData);
      setTipos(tiposData);
    } catch (error) {
      console.error("Error cargando tipos:", error);
      toast.error("Error al cargar los tipos");
    } finally {
      setLoading(false);
    }
  };

  const filterTipos = () => {
    if (!Array.isArray(tipos)) {
      setFilteredTipos([]);
      return;
    }

    if (!searchTerm.trim()) {
      setFilteredTipos(tipos);
    } else {
      const filtered = tipos.filter((tipo) => tipo.nombre && tipo.nombre.toLowerCase().includes(searchTerm.toLowerCase()));
      setFilteredTipos(filtered);
    }
  };

  // Normaliza bits devueltos por SQL Server para que switches y badges no traten "0" como verdadero.
  const isTruthyValue = (value) => value === true || value === 1 || value === "1";

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nombre.trim()) {
      toast.error("El nombre es obligatorio");
      return;
    }

    try {
      // Obtener los IDs de los documentos checkeados (obligatorios)
      const documentosCheckeados = documentosObligatorios.filter((doc) => doc.OBLIGATORIO === 1 || doc.OBLIGATORIO === true).map((doc) => doc.ID);

      // Convertir a cadena separada por punto y coma para enviar al backend
      const documentosObligatoriosCadena = documentosCheckeados.join(";");

      if (editingTipo) {
        // Validar que tengamos un ID válido
        if (!editingTipo.id || editingTipo.id === "sin-id") {
          toast.error("Error: No se pudo identificar el ID del tipo a editar");
          console.error("ID inválido para editar:", editingTipo);
          return;
        }

        // Obtener el ID de la categoría según la selección actual
        let categoriaId;
        switch (selectedCategory) {
          case "funciones-departamento":
            categoriaId = 1;
            break;
          case "contrato-horas":
            categoriaId = 2;
            break;
          case "relacion-laboral":
            categoriaId = 3;
            break;
          case "factores-seguimiento":
            categoriaId = 4;
            break;
          case "documentos":
            categoriaId = 5;
            break;
          default:
            categoriaId = 0;
        }

        // Actualizar el tipo usando el servicio con los parámetros adicionales
        const updateData = {
          ...formData,
          categoriaId,
          estado: formData.activo,
          // Incluir documentos obligatorios si es un departamento
          documentosObligatorios: selectedCategory === "funciones-departamento" ? documentosObligatoriosCadena : null,
          // Hora opcional para notificación al fichar entrada (solo departamentos)
          envioNotificacionFicharEntrada: selectedCategory === "funciones-departamento" ? formData.envioNotificacionFicharEntrada || null : null,
          ...(selectedCategory === "documentos" && formData.documentoSinRenovacion ? { diasAvisoCaducaPronto: 0 } : {}),
        };

        console.log("Datos para actualización:", {
          editingTipo,
          editingTipoId: editingTipo.id,
          updateData,
          documentosCheckeados,
        });

        await tiposService.updateTipo(editingTipo.id, updateData);
        toast.success("Tipo actualizado correctamente");
      } else {
        // Crear nuevo tipo (incluye categoría documentos con categoriaId 5)
        // Obtener el ID de la categoría según la selección actual
        let categoriaId;
        switch (selectedCategory) {
          case "funciones-departamento":
            categoriaId = 1;
            break;
          case "contrato-horas":
            categoriaId = 2;
            break;
          case "relacion-laboral":
            categoriaId = 3;
            break;
          case "factores-seguimiento":
            categoriaId = 4;
            break;
          case "documentos":
            categoriaId = 5;
            break;
          default:
            categoriaId = 0;
        }

        // Crear el tipo usando el servicio con los parámetros adicionales
        const createData = {
          ...formData,
          categoriaId,
          estado: formData.activo,
          documentosObligatorios: selectedCategory === "funciones-departamento" ? documentosObligatoriosCadena : null,
          envioNotificacionFicharEntrada: selectedCategory === "funciones-departamento" ? formData.envioNotificacionFicharEntrada || null : null,
          // Plantillas ocultas en UI: nuevos tipos sin plantillas y sin envío
          ...(selectedCategory === "documentos"
            ? {
                plantillaVisualmax: "",
                plantillaAutonomo: "",
                envioPlantilla: false,
                ...(formData.documentoSinRenovacion ? { diasAvisoCaducaPronto: 0 } : {}),
              }
            : {}),
        };

        console.log("Datos para creación:", {
          selectedCategory,
          categoriaId,
          createData,
          documentosCheckeados,
        });

        await tiposService.createTipo(createData);
        toast.success("Tipo creado correctamente");
      }

      setShowModal(false);
      resetForm();
      loadTipos();
    } catch (error) {
      console.error("Error guardando tipo:", error);
      const msg = error.response?.data?.message || error.message || "Error al guardar el tipo";
      toast.error(msg);
    }
  };

  // Normaliza el valor de hora del backend (ISO "1970-01-01T08:30:00.000Z", "HH:mm:ss", etc.) a "HH:mm" para input type="time"
  const normalizeTimeForInput = (value) => {
    if (value == null || value === "") return "";
    if (typeof value === "string") {
      const s = value.trim();
      // ISO: "1970-01-01T08:30:00.000Z" o "2024-01-01T08:30:00"
      const isoMatch = s.match(/T(\d{1,2}):(\d{2})/);
      if (isoMatch) return `${isoMatch[1].padStart(2, "0")}:${isoMatch[2]}`;
      // "08:30" o "08:30:00" o "08:30:00.0000000"
      const timeMatch = s.match(/^(\d{1,2}):(\d{2})/);
      return timeMatch ? `${timeMatch[1].padStart(2, "0")}:${timeMatch[2]}` : "";
    }
    if (value instanceof Date) {
      return value.toTimeString().slice(0, 5);
    }
    return "";
  };

  const handleEdit = async (tipo) => {
    console.log("Tipo seleccionado para editar:", tipo);
    console.log("ID del tipo:", tipo.id);
    setEditingTipo(tipo);
    setShowModal(true);

    if (selectedCategory === "funciones-departamento" && tipo.id) {
      // Cargar detalle del departamento (incluye ENVIO_NOTIFICACION_FICHAR_ENTRADA que el listado puede no traer)
      try {
        const res = await tiposService.getDepartamentoById(tipo.id);
        const d = res.data?.departamento;
        if (d) {
          setFormData({
            nombre: d.NOMBRE ?? tipo.nombre,
            activo: d.ACTIVO !== undefined ? isTruthyValue(d.ACTIVO) : tipo.activo !== undefined ? isTruthyValue(tipo.activo) : true,
            envioNotificacionFicharEntrada: normalizeTimeForInput(d.ENVIO_NOTIFICACION_FICHAR_ENTRADA),
            mesesHastaProxRenovacion: "",
            diasAvisoCaducaPronto: 30,
            documentoSinRenovacion: false,
            plantillaVisualmax: "",
            plantillaAutonomo: "",
            envioPlantilla: false,
          });
        } else {
          setFormData({
            nombre: tipo.nombre,
            activo: tipo.activo !== undefined ? isTruthyValue(tipo.activo) : true,
            envioNotificacionFicharEntrada: normalizeTimeForInput(tipo.ENVIO_NOTIFICACION_FICHAR_ENTRADA ?? tipo.envioNotificacionFicharEntrada),
            mesesHastaProxRenovacion: "",
            diasAvisoCaducaPronto: 30,
            documentoSinRenovacion: false,
            plantillaVisualmax: "",
            plantillaAutonomo: "",
            envioPlantilla: false,
          });
        }
      } catch (err) {
        console.error("Error cargando detalle departamento:", err);
        setFormData({
          nombre: tipo.nombre,
          activo: tipo.activo !== undefined ? isTruthyValue(tipo.activo) : true,
          envioNotificacionFicharEntrada: normalizeTimeForInput(tipo.ENVIO_NOTIFICACION_FICHAR_ENTRADA ?? tipo.envioNotificacionFicharEntrada),
          mesesHastaProxRenovacion: "",
          diasAvisoCaducaPronto: 30,
          documentoSinRenovacion: false,
          plantillaVisualmax: "",
          plantillaAutonomo: "",
          envioPlantilla: false,
        });
      }
      await loadDocumentosObligatorios(tipo.id);
    } else {
      setFormData({
        nombre: tipo.nombre,
        activo: tipo.ACTIVO !== undefined ? isTruthyValue(tipo.ACTIVO) : tipo.activo !== undefined ? isTruthyValue(tipo.activo) : true,
        envioNotificacionFicharEntrada: normalizeTimeForInput(tipo.ENVIO_NOTIFICACION_FICHAR_ENTRADA ?? tipo.envioNotificacionFicharEntrada),
        mesesHastaProxRenovacion: isTruthyValue(tipo.DOCUMENTO_SIN_RENOVACION) ? "" : (tipo.MESES_HASTA_PROX_RENOVACION ?? ""),
        diasAvisoCaducaPronto: isTruthyValue(tipo.DOCUMENTO_SIN_RENOVACION) ? "" : (tipo.DIAS_AVISO_CADUCA_PRONTO ?? ""),
        documentoSinRenovacion: isTruthyValue(tipo.DOCUMENTO_SIN_RENOVACION),
        plantillaVisualmax: tipo.PLANTILLA_VISUALMAX || "",
        plantillaAutonomo: tipo.PLANTILLA_AUTONOMO || "",
        envioPlantilla: isTruthyValue(tipo.ENVIO_PLANTILLA),
      });
    }
  };

  // Función para cargar documentos obligatorios de un departamento
  const loadDocumentosObligatorios = async (departamentoId) => {
    setLoadingDocumentos(true);
    try {
      const response = await tiposService.getDocumentosObligatoriosDepartamento(departamentoId);
      console.log("Documentos obligatorios:", response.data);
      if (response.data.success) {
        setDocumentosObligatorios(response.data.documentos || []);
      } else {
        setDocumentosObligatorios([]);
      }
    } catch (error) {
      console.error("Error cargando documentos obligatorios:", error);
      setDocumentosObligatorios([]);
    } finally {
      setLoadingDocumentos(false);
    }
  };

  // Función para manejar el cambio de checkbox de documento obligatorio
  const handleDocumentoObligatorioChange = (documentoId, checked) => {
    setDocumentosObligatorios((prev) => prev.map((doc) => (doc.ID === documentoId ? { ...doc, OBLIGATORIO: checked } : doc)));
  };

  const resetForm = () => {
    setFormData({
      nombre: "",
      activo: true,
      envioNotificacionFicharEntrada: "",
      mesesHastaProxRenovacion: "",
      diasAvisoCaducaPronto: "",
      documentoSinRenovacion: false,
      plantillaVisualmax: "",
      plantillaAutonomo: "",
      envioPlantilla: false,
    });
    setEditingTipo(null);
    setDocumentosObligatorios([]);
  };

  const openCreateModal = async () => {
    resetForm();
    setShowModal(true);

    // Si es funciones-departamento, cargar documentos con departamentoId = 0 (nuevo)
    if (selectedCategory === "funciones-departamento") {
      await loadDocumentosObligatorios(0);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    resetForm();
  };

  const getStatusBadge = (activo) => {
    return isTruthyValue(activo) ? (
      <Badge bg="success" className="status-badge">
        Activo
      </Badge>
    ) : (
      <Badge bg="secondary" className="status-badge">
        Inactivo
      </Badge>
    );
  };

  const isDocumentosCategory = selectedCategory === "documentos";

  if (loading) {
    return (
      <Container className="mt-4 tipos-container">
        <div className="loading-spinner">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Cargando...</span>
          </Spinner>
          <p className="mt-2">Cargando {categorias.find((cat) => cat.id === selectedCategory)?.nombre.toLowerCase()}...</p>
        </div>
      </Container>
    );
  }

  return (
    <Container className="mt-4 tipos-container">
      <Row className="mb-4">
        <Col>
          <div className="tipos-header">
            <h2>Gestión de Tipos del Sistema</h2>
            <p>{categorias.find((cat) => cat.id === selectedCategory)?.descripcion}</p>
          </div>
        </Col>
        <Col xs="auto" className="d-flex align-items-center">
          <Button className="create-button" onClick={openCreateModal}>
            <FaPlus className="me-2" />
            Nuevo Tipo
          </Button>
        </Col>
      </Row>

      {/* Selector de categorías y buscador */}
      <Row className="mb-3">
        <Col>
          <div className="search-container">
            <div className="d-flex flex-column gap-3">
              <div className="category-buttons">
                {categorias.map((categoria) => (
                  <Button
                    key={categoria.id}
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => setSelectedCategory(categoria.id)}
                    className={`category-button ${selectedCategory === categoria.id ? "active" : ""}`}
                  >
                    <span>{categoria.icon}</span>
                    {categoria.nombre}
                  </Button>
                ))}
              </div>

              <div className="search-input-container">
                <InputGroup>
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                  <FormControl placeholder="Buscar tipos..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} />
                </InputGroup>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Tabla de tipos */}
      <div className="tipos-table">
        <Table responsive striped hover className={`tipos-data-table ${isDocumentosCategory ? "tipos-data-table-documentos" : ""}`}>
          <thead>
            <tr>
              <th className="nombre-column">Nombre</th>
              <th className="estado-column">Estado</th>
              {isDocumentosCategory && (
                <>
                  <th>Meses renovación</th>
                  <th>Días aviso</th>
                </>
              )}
              <th className="acciones-column">Acciones</th>
            </tr>
          </thead>
          <tbody>
            {!Array.isArray(filteredTipos) || filteredTipos.length === 0 ? (
              <tr>
                <td colSpan={isDocumentosCategory ? 5 : 3}>
                  <div className="empty-state-container">
                    <div className="empty-icon">📋</div>
                    <h4>
                      {searchTerm
                        ? "No se encontraron resultados"
                        : `No hay ${categorias.find((cat) => cat.id === selectedCategory)?.nombre.toLowerCase()}`}
                    </h4>
                    <p>
                      {searchTerm
                        ? `No se encontraron tipos que coincidan con "${searchTerm}"`
                        : isDocumentosCategory
                          ? "Puedes crear un tipo de documento con el botón «Nuevo Tipo» o editar los existentes."
                          : `Comienza creando tu primer ${categorias.find((cat) => cat.id === selectedCategory)?.nombre.toLowerCase()} haciendo clic en el botón 'Nuevo Tipo'`}
                    </p>
                    {!searchTerm && (
                      <Button variant="primary" onClick={openCreateModal}>
                        <FaPlus className="me-2" />
                        Crear Primer {categorias.find((cat) => cat.id === selectedCategory)?.nombre}
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            ) : (
              (Array.isArray(filteredTipos) ? filteredTipos : []).map((tipo) => (
                <tr key={tipo.id}>
                  <td>
                    <strong>{tipo.nombre}</strong>
                  </td>
                  <td>{getStatusBadge(tipo.ACTIVO)}</td>
                  {isDocumentosCategory && (
                    <>
                      <td>{tipo.MESES_HASTA_PROX_RENOVACION ?? "-"}</td>
                      <td>
                        {isTruthyValue(tipo.DOCUMENTO_SIN_RENOVACION)
                          ? "-"
                          : tipo.DIAS_AVISO_CADUCA_PRONTO != null && tipo.DIAS_AVISO_CADUCA_PRONTO !== ""
                            ? tipo.DIAS_AVISO_CADUCA_PRONTO
                            : "-"}
                      </td>
                    </>
                  )}
                  <td>
                    <div className="action-buttons">
                      <Button variant="outline-warning" size="sm" onClick={() => handleEdit(tipo)} title="Editar">
                        <FaEdit />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      {/* Modal para crear/editar */}
      <Modal show={showModal} onHide={closeModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {editingTipo
              ? `Editar ${categorias.find((cat) => cat.id === selectedCategory)?.nombre}`
              : `Nuevo ${categorias.find((cat) => cat.id === selectedCategory)?.nombre}`}
          </Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Nombre *</Form.Label>
                  <Form.Control
                    type="text"
                    value={formData.nombre}
                    onChange={(e) => setFormData({ ...formData, nombre: e.target.value })}
                    placeholder="Ingrese el nombre del tipo"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6} style={{ justifyItems: "center" }}>
                <Form.Group className="mb-3">
                  <Form.Label>Estado</Form.Label>
                  <Form.Check
                    type="switch"
                    id="activo-switch"
                    label="Activo"
                    checked={formData.activo}
                    onChange={(e) => setFormData({ ...formData, activo: e.target.checked })}
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Hora opcional para envío de notificación al fichar entrada - Solo para funciones-departamento */}
            {selectedCategory === "funciones-departamento" && (
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Envío notificación fichar entrada</Form.Label>
                    <Form.Control
                      type="time"
                      value={formData.envioNotificacionFicharEntrada}
                      onChange={(e) => setFormData({ ...formData, envioNotificacionFicharEntrada: e.target.value })}
                      title="Hora opcional para enviar notificación al fichar entrada"
                    />
                    <Form.Text className="text-muted">Opcional. Dejar vacío si no se usa.</Form.Text>
                  </Form.Group>
                </Col>
              </Row>
            )}

            {/* Tabla de documentos obligatorios - Solo para funciones-departamento */}
            {selectedCategory === "funciones-departamento" && (
              <div className="mt-4">
                <h6 className="mb-3">Documentos Obligatorios</h6>
                {loadingDocumentos ? (
                  <div className="text-center py-3">
                    <Spinner animation="border" size="sm" />
                    <span className="ms-2">Cargando documentos...</span>
                  </div>
                ) : documentosObligatorios.length > 0 ? (
                  <Table striped bordered hover size="sm">
                    <thead>
                      <tr>
                        <th>Documento</th>
                        <th style={{ width: "120px", textAlign: "center" }}>Obligatorio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {documentosObligatorios.map((doc) => (
                        <tr key={doc.ID}>
                          <td>{doc.NOMBRE}</td>
                          <td style={{ textAlign: "center" }}>
                            <Form.Check
                              type="checkbox"
                              checked={doc.OBLIGATORIO == 1 || doc.OBLIGATORIO == true}
                              onChange={(e) => handleDocumentoObligatorioChange(doc.ID, e.target.checked)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <p className="text-muted">No hay documentos disponibles</p>
                )}
              </div>
            )}

            {/* Campos específicos de DOCUMENTOS_TIPOS (alta y edición). */}
            {isDocumentosCategory && (
              <>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Meses hasta próxima renovación</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        value={formData.mesesHastaProxRenovacion}
                        disabled={formData.documentoSinRenovacion}
                        onChange={(e) => setFormData({ ...formData, mesesHastaProxRenovacion: e.target.value })}
                        placeholder="Dejar vacío si no aplica"
                      />
                      <Form.Text className="text-muted">Se ignora cuando el documento no requiere renovación.</Form.Text>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Opciones del documento</Form.Label>
                      <Form.Check
                        type="switch"
                        id="documento-sin-renovacion-switch"
                        label="Documento sin renovación"
                        checked={formData.documentoSinRenovacion}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            documentoSinRenovacion: e.target.checked,
                            mesesHastaProxRenovacion: e.target.checked ? "" : formData.mesesHastaProxRenovacion,
                            diasAvisoCaducaPronto: e.target.checked ? "" : formData.diasAvisoCaducaPronto,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Días antes del aviso Caduca pronto</Form.Label>
                      <Form.Control
                        type="number"
                        min="0"
                        value={formData.diasAvisoCaducaPronto}
                        disabled={formData.documentoSinRenovacion}
                        onChange={(e) => setFormData({ ...formData, diasAvisoCaducaPronto: e.target.value })}
                        placeholder="30"
                      />
                      <Form.Text className="text-muted">
                        {formData.documentoSinRenovacion ? "No aplica: el documento no tiene caducidad." : "Aviso de caducidad próxima."}
                      </Form.Text>
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={closeModal}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit">
              {editingTipo ? "Actualizar" : "Crear"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </Container>
  );
};

export default TiposList;
